import React from 'react';
import { Navigate } from 'react-router';
import Base from '../Base';
//npm i react-querybuilder
import { QueryBuilder, formatQuery } from "react-querybuilder";
import "react-querybuilder/dist/query-builder.css";
import SelectAsync from 'react-select/async';

const translations = {
    fields: {
        title: "فیلد",
    },
    operators: {
        title: "عملگر",
        equals: "برابر با",
        notEquals: "نابرابر با",
        lessThan: "کمتر از",
        lessThanOrEqual: "کوچکتر یا مساوی",
        greaterThan: "بزرگتر از",
        greaterThanOrEqual: "بزرگتر یا مساوی",
        contains: "شامل",
        doesNotContain: "شامل نباشد",
        beginsWith: "شروع شود با",
        endsWith: "پایان یابد با",
        in: "یکی از",
        notIn: "هیچ‌کدام از",
        isNull: "خالی باشد",
        isNotNull: "خالی نباشد",
        isEmpty: "رشته خالی باشد",
        isNotEmpty: "رشته خالی نباشد",
    },
    value: {
        title: "مقدار",
    },
    removeRule: {
        label: "حذف شرط",
        title: "حذف این شرط",
    },
    removeGroup: {
        label: "حذف گروه",
        title: "حذف این گروه",
    },
    addRule: {
        label: "افزودن شرط",
        title: "افزودن شرط جدید",
    },
    addGroup: {
        label: "افزودن گروه",
        title: "افزودن گروه جدید",
    },
    combinators: {
        title: "ترکیب‌کننده",
        and: "و",
        or: "یا",
    },
    notToggle: {
        title: "نقیض",
        label: "نقیض (NOT)",
    },
    valueSourceSelector: {
        title: "نوع مقدار",
        value: "مقدار ثابت",
        field: "مقایسه با فیلد دیگر",
    },
    operatorPlaceholder: "انتخاب عملگر",
    fieldPlaceholder: "انتخاب فیلد",
    valuePlaceholder: "وارد کردن مقدار",
};
const persianOperators = [
    { name: '=', label: 'برابر با' },
    { name: '!=', label: 'نابرابر با' },
    { name: '<', label: 'کمتر از' },
    { name: '<=', label: 'کوچکتر یا مساوی' },
    { name: '>', label: 'بزرگتر از' },
    { name: '>=', label: 'بزرگتر یا مساوی' },
    { name: 'contains', label: 'شامل' },
    { name: 'doesNotContain', label: 'شامل نباشد' },
    { name: 'beginsWith', label: 'شروع شود با' },
    { name: 'endsWith', label: 'پایان یابد با' },
    { name: 'in', label: 'یکی از' },
    { name: 'notIn', label: 'هیچ‌کدام از' },
    { name: 'null', label: 'خالی باشد' },
    { name: 'notNull', label: 'خالی نباشد' },
    { name: 'empty', label: 'رشته خالی باشد' },
    { name: 'notEmpty', label: 'رشته خالی نباشد' }
];
const persianCombinators = [
    { name: 'and', label: 'و' },
    { name: 'or', label: 'یا' }
];
export default class Report extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: this.isNull(props.Id) ? this.defaultGuid() : props.Id,
            caller: props.Caller,
            data: null,
            loading: true,
            innerStatus: 0,
            fields: [],
            dataSourceFields: [],
            version: this.uuidv4(),
            selectedTables: [],
            selectedColumns: [],
            groupByColumns: [],
            aggregateColumns: [],
            joins: [],
            query: {},
            metadata: [],
            userGroups: []
        };
        this.keyDownFunction = this.keyDownFunction.bind(this);
    }
    //handleTableSelection = (event) => {
    //    const options = event.target.options;
    //    const selectedTables = [];
    //    for (let i = 0; i < options.length; i++) {
    //        if (options[i].selected) selectedTables.push(options[i].value);
    //    }
    //    this.setState({ selectedTables, query: { combinator: "and", rules: [] } });
    //};
    toggleColumn = (table, field) => {
        const fieldName = `${table}.${field.name}`;
        this.setState((prev) => {
            const exists = prev.selectedColumns.find((c) => c.name === fieldName);
            if (exists) {
                return {
                    selectedColumns: prev.selectedColumns.filter((c) => c.name !== fieldName),
                };
            } else {
                return {
                    selectedColumns: [
                        ...prev.selectedColumns,
                        {
                            name: fieldName,
                            label: `${this.state.metadata[table].label} - ${field.label}`,
                            alias: field.label, orderby: '',
                            display: true,
                            type: field.type,
                            dataType: field.dataType,
                            enumName: field.enumName,
                        },
                    ],
                };
            }
        });
    }
    moveColumn = (index, direction) => {
        this.setState((prev) => {
            const newCols = [...prev.selectedColumns];
            const targetIndex = index + direction;
            if (targetIndex < 0 || targetIndex >= newCols.length) return {};
            const [removed] = newCols.splice(index, 1);
            newCols.splice(targetIndex, 0, removed);
            return { selectedColumns: newCols };
        });
    }
    changeAlias = (index, value) => {
        this.setState((prev) => {
            const newCols = [...prev.selectedColumns];
            newCols[index].alias = value;
            return { selectedColumns: newCols };
        });
    }
    changeOrderBy = (index, value) => {
        this.setState((prev) => {
            const newCols = [...prev.selectedColumns];
            newCols[index].orderby = value;
            return { selectedColumns: newCols };
        });
    }
    changeDisplay = (index, value) => {
        this.setState((prev) => {
            const newCols = [...prev.selectedColumns];
            newCols[index].display = value;
            return { selectedColumns: newCols };
        });
    }
    addJoin = () => {
        this.setState((prev) => ({
            joins: [
                ...prev.joins,
                { from: "", to: "", fromField: "", toField: "", type: "INNER" },
            ],
        }));
    };
    updateJoin = (index, key, value) => {
        const joins = [...this.state.joins];
        joins[index][key] = value;
        this.setState({ joins });
    }
    handleQueryChange = (query) => {
        const { metadata, selectedTables } = this.state;

        // همه فیلدهای انتخابی از متادیتا
        const allFields = selectedTables.flatMap(
            (tbl) => metadata[tbl]?.fields.map((f) => ({
                name: `${tbl}.${f.name}`,
                type: f.type || "string", // پیش‌فرض string
                dataType: f.dataType || 1,
            })) || []
        );

        // تابع بازگشتی برای enrich کردن rules
        const enrichRules = (rules) =>
            rules.map((r) => {
                if (r.rules) {
                    // اگر group هست
                    return { ...r, rules: enrichRules(r.rules) };
                }

                // پیدا کردن متای فیلد مربوطه
                const fieldMeta = allFields.find((f) => f.name === r.field);

                return {
                    ...r,
                    type: fieldMeta?.type || "string",
                    dataType: fieldMeta?.dataType || 1,
                };
            });

        const enrichedQuery = {
            ...query,
            rules: enrichRules(query.rules || []),
        };

        this.setState({ query: enrichedQuery });
        //this.setState({ query });
    }
    groupMetadata(flatMeta) {
        const grouped = {};

        flatMeta.forEach(item => {
            if (!grouped[item.name]) {
                grouped[item.name] = {
                    label: item.label,
                    fields: item.fields
                };
            }
        });

        return grouped;
    }
    componentDidMount() {
        this.addKeyDown();
        this.httpPost("api/v1/report/get", {
            id: this.state.id,
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                if (data.status === 1) {
                    this.state.userGroups = data.record.userGroups;
                    var generatedQuery = JSON.parse(data.record.generatedQuery);
                    this.state.selectedTables = generatedQuery.tables;
                    this.state.selectedColumns = generatedQuery.select;
                    this.state.joins = generatedQuery.joins;
                    this.state.query = generatedQuery.query;

                    this.state.groupByColumns = generatedQuery.groupBy;
                    this.state.aggregateColumns = generatedQuery.aggregates;

                    this.state.metadata = this.groupMetadata(data.record.dataSources);

                    this.setState({
                        data: data,
                        version: this.uuidv4(),
                        loading: false
                    });
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    save(e) {
        if (!this.isNull(e)) e.preventDefault();
        if (this.isBlank(this.state.data.record.order)) this.state.data.record.order = 0;
        this.httpPost("api/v1/report/save", {
            id: this.state.id,
            title: this.state.data.record.title,
            order: this.state.data.record.order,
            reportType: this.state.data.record.reportType,
            status: this.state.data.record.status,
            query: JSON.stringify({
                tables: this.state.selectedTables,
                select: this.state.selectedColumns,
                joins: this.state.joins,
                query: this.state.query,
                groupBy: this.state.groupByColumns,
                aggregates: this.state.aggregateColumns,
            }, null, 2),
            pageOrientation: this.state.data.record.pageOrientation,
            allowExport: this.state.data.record.allowExport,
            userGroups: this.state.userGroups
        })
            .then(data => {
                if (data.status === -1) window.location.href = "/login";
                this.state.innerStatus = data.innerStatus;
                if (data.status === 1) {
                    this.showSuccessMessage("گزارش با موفقیت ذخیره شد");
                    this.state.caller.refreshData();
                    this.closeMe();
                }
                else {
                    this.showErorrMessage(data.message);
                    this.setState({
                        loading: false
                    });
                }
            });
    }
    setType(e) {
        this.state.data.record.reportType = e;
        this.setState({ data: this.state.data });
    }
    setUserGroups(e) {
        this.state.userGroups = e;
    }
    changeGroupBy = (fieldName, checked) => {
        this.setState((prev) => {
            let groupByColumns = [...prev.groupByColumns];
            if (checked) {
                if (!groupByColumns.includes(fieldName)) groupByColumns.push(fieldName);
            } else {
                groupByColumns = groupByColumns.filter(f => f !== fieldName);
            }
            return { groupByColumns };
        });
    }
    changeAggregate = (fieldName, func) => {
        this.setState((prev) => {
            let aggregateColumns = [...prev.aggregateColumns];
            // حذف اگر قبلا بوده
            aggregateColumns = aggregateColumns.filter(a => a.field !== fieldName);
            if (func !== "") {
                aggregateColumns.push({
                    field: fieldName,
                    function: func,
                    alias: fieldName + "_agg",//برای جلوگیری از جایگزین شدن مقادیر با enum ها
                });
            }
            return { aggregateColumns };
        });
    }


    // استخراج نام جدول از "Table.Field"
    getTableFromField = (fullName) => (fullName || "").split(".")[0] || "";

    // بازگشتی: تمیز کردن گروه/قواعد کوئری بر اساس جدول‌های مجاز
    pruneQueryByTables = (node, allowedTables) => {
        if (!node) return { combinator: "and", rules: [] };

        // اگر گره قانون ساده است (rule)
        if (!node.rules) {
            const tbl = this.getTableFromField(node.field);
            return allowedTables.includes(tbl) ? node : null;
        }

        // اگر گره گروه است
        const prunedRules = (node.rules || [])
            .map((r) => this.pruneQueryByTables(r, allowedTables))
            .filter(Boolean);

        if (prunedRules.length === 0) return null;

        // حفظ سایر ویژگی‌ها مثل not
        return { ...node, rules: prunedRules };
    };

    // همه‌ی stateهای وابسته به جدول‌های انتخابی را هماهنگ/پاکسازی کن
    cleanupStateForTables = (newSelectedTables) => {
        const isAllowedField = (fullName) =>
            newSelectedTables.includes(this.getTableFromField(fullName));

        const cleanedSelectedColumns = (this.state.selectedColumns || []).filter((c) =>
            isAllowedField(c.name)
        );

        const cleanedGroupBy = (this.state.groupByColumns || []).filter(isAllowedField);

        const cleanedAggregates = (this.state.aggregateColumns || []).filter((a) =>
            isAllowedField(a.field)
        );

        const cleanedJoins = (this.state.joins || []).filter(
            (j) => newSelectedTables.includes(j.from) && newSelectedTables.includes(j.to)
        );

        const pruned = this.pruneQueryByTables(this.state.query, newSelectedTables);
        const cleanedQuery = pruned || { combinator: "and", rules: [] };

        this.setState({
            selectedTables: newSelectedTables,
            selectedColumns: cleanedSelectedColumns,
            groupByColumns: cleanedGroupBy,
            aggregateColumns: cleanedAggregates,
            joins: cleanedJoins,
            query: cleanedQuery,
        });
    };

    // تیک‌زدن/برداشتن هر جدول
    toggleTable = (tbl, checked) => {
        const prev = this.state.selectedTables || [];
        let next;

        if (checked) {
            // جلوگیری از دوباره اضافه‌شدن
            next = prev.includes(tbl) ? prev : [...prev, tbl];
        } else {
            next = prev.filter((t) => t !== tbl);
        }

        // هماهنگ‌سازی بقیه‌ی stateها
        this.cleanupStateForTables(next);
    };
    renderForm() {
        const { selectedTables, selectedColumns, joins, query, metadata } = this.state;
        // فیلدهای همه جداول انتخابی رو یکی می‌کنیم
        const allFields = selectedTables.flatMap((tbl) =>
            metadata[tbl]?.fields.map((f) => ({
                ...f,
                name: `${tbl}.${f.name}`, // namespace: Table.Field
                label: `${metadata[tbl].label} - ${f.label}`,
                dataType: f.dataType,
                type: f.type,
            }))
        );

        return <div className="modal fade listModal in show" tabIndex="-1" role="dialog">
            <div className="modal-backdrop fade in" style={{ "height": "100%" }} onClick={e => this.closeMe()}></div>
            <div className="modal-dialog ui-draggable" style={{ "minWidth": "90%" }}>
                <div className="modal-content">
                    <div className="modal-body" style={{ "padding": "0" }}>
                        <div className="modal-header modal-header-info">
                            <button type="button" className="close" onClick={e => this.closeMe()} aria-label="Close"><span aria-hidden="true">×</span></button>
                            <h4 className="modal-title">
                                {this.state.data.record.id !== this.defaultGuid() ? "ویرایش گزارش" : "افزودن گزارش جدید"}
                            </h4>
                        </div>
                        <div className="modal-body">
                            <div className="container-fluid">
                                {this.renderSystemModuleModuleAccessMessage(this.state.innerStatus)}

                                <div className="row">
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label for="name" className="title1">عنوان</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.title} onChange={e => this.state.data.record.title = e.target.value} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">اولویت</label><span className="red">*</span>
                                            <input defaultValue={this.state.data.record.order} onChange={e => this.state.data.record.order = parseInt(e.target.value)} autocomplete="off" type="text" className="form-control input-sm" maxlength="100" />
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">وضعیت</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.status} onChange={e => this.state.data.record.status = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="1">فعال</option>
                                                <option value="2">غیرفعال</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">نوع گزارش</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.reportType} onChange={e => this.setType(parseInt(e.target.value))} autocomplete="off" className="form-control input-sm">
                                                <option value="0">انتخاب کنید</option>
                                                <option value="1">لیست ساده</option>
                                                <option value="2">نمودار Pie</option>
                                                <option value="3">نمودار Line</option>
                                                <option value="4">نمودار Bar</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">مجوز چاپ</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.allowExport ? "1" : "2"} onChange={e => this.state.data.record.allowExport = (e.target.value === "1")} autocomplete="off" className="form-control input-sm">
                                                <option value="1">دارد</option>
                                                <option value="2">ندارد</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-sm-2">
                                        <div className="form-group">
                                            <label for="name" className="title1">جهت چاپ</label><span className="red">*</span>
                                            <select defaultValue={this.state.data.record.pageOrientation} onChange={e => this.state.data.record.pageOrientation = parseInt(e.target.value)} autocomplete="off" className="form-control input-sm">
                                                <option value="1">افقی</option>
                                                <option value="2">عمودی</option>
                                            </select>
                                        </div>
                                    </div>

                                    <div className="col-lg-12">
                                        <div className="form-group">
                                            <label className="form-label">گروه کاربران مجاز به مشاهده گزارش</label>
                                            <div className="form-control-wrap">
                                                <SelectAsync
                                                    defaultValue={this.state.userGroups}
                                                    isMulti={true}
                                                    placeholder="انتخاب گروه ها"
                                                    defaultOptions
                                                    loadOptions={(inputValue, callback) => this.loadUserGroupsOptions(inputValue, callback)}
                                                    onChange={e => this.setUserGroups(e)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>جداول مورد نظر جهت استخراج را انتخاب نمایید:</label>
                                            <div className="row" style={{ margin: 0, maxHeight: 220, overflowY: "auto", border: "1px solid #eee", padding: 10, background: "#fff" }}>
                                                {Object.keys(metadata).map((tbl) => (
                                                    <div className="col-sm-3" key={tbl} style={{ marginBottom: 6 }}>
                                                        <label style={{ display: "flex", alignItems: "center", gap: 6 }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={selectedTables.includes(tbl)}
                                                                onChange={(e) => this.toggleTable(tbl, e.target.checked)}
                                                            />
                                                            <span>{metadata[tbl].label}</span>
                                                        </label>
                                                    </div>
                                                ))}
                                            </div>

                                            {/*<div style={{ marginTop: 8, display: "flex", gap: 8 }}>*/}
                                            {/*    <button*/}
                                            {/*        type="button"*/}
                                            {/*        className="btn btn-default btn-sm"*/}
                                            {/*        onClick={() => this.cleanupStateForTables(Object.keys(metadata))}*/}
                                            {/*    >*/}
                                            {/*        انتخاب همه*/}
                                            {/*    </button>*/}
                                            {/*    <button*/}
                                            {/*        type="button"*/}
                                            {/*        className="btn btn-default btn-sm"*/}
                                            {/*        onClick={() => this.cleanupStateForTables([])}*/}
                                            {/*    >*/}
                                            {/*        پاک ‌کردن همه*/}
                                            {/*    </button>*/}
                                            {/*</div>*/}
                                        </div>
                                    </div>

                                    {selectedTables.length > 0 && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>فیلدهای مورد نظر از هر جدول اطلاعاتی رو که قصد خروجی گرفتن دارید را انتخاب نمایید: </label>
                                            <ul className="nav nav-tabs mt-n3" role="tablist">
                                                {selectedTables.map((tbl, index) => <li className="nav-item" role="presentation">
                                                    <a className={"nav-link " + (index === 0 ? "active" : "")} data-bs-toggle="tab" href={"#tab_" + tbl} aria-selected="false" role="tab" tabindex="-1"><span>{metadata[tbl].label}</span></a>
                                                </li>
                                                )}
                                            </ul>

                                            <div className="tab-content">
                                                {selectedTables.map((tbl, index) =>
                                                    <div className={"tab-pane " + (index === 0 ? "active" : "")} id={"tab_" + tbl} role="tabpanel">
                                                        {metadata[tbl].fields.map((f) => (
                                                            <label key={f.name} style={{ display: "block" }}>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={!!selectedColumns.find((c) => c.name === `${tbl}.${f.name}`)}
                                                                    onChange={() => this.toggleColumn(tbl, f)}
                                                                    style={{ "marginLeft": "5px" }}
                                                                />
                                                                {f.label}
                                                            </label>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>}

                                    {selectedColumns.length > 0 && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>گروه‌بندی (Group By) و توابع جمعی (Aggregates):</label>
                                            <table border="1" cellPadding="5" style={{ width: "100%", background: "#fff", marginTop: 10 }}>
                                                <thead>
                                                    <tr>
                                                        <th>ستون</th>
                                                        <th>گروه بندی شود؟</th>
                                                        <th>تابع تجمیعی</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {selectedColumns.map((col, idx) => (
                                                        <tr key={col.name}>
                                                            <td>{col.label}</td>
                                                            <td>
                                                                <input
                                                                    type="checkbox"
                                                                    checked={this.state.groupByColumns.includes(col.name)}
                                                                    onChange={(e) => this.changeGroupBy(col.name, e.target.checked)}
                                                                />
                                                            </td>
                                                            <td>
                                                                <select
                                                                    className="form-control"
                                                                    value={
                                                                        this.state.aggregateColumns.find(a => a.field === col.name)?.function || ""
                                                                    }
                                                                    onChange={(e) => this.changeAggregate(col.name, e.target.value)}
                                                                >
                                                                    <option value="">ندارد</option>
                                                                    {col.type === "number" && <option value="SUM">جمع</option>}
                                                                    <option value="COUNT">تعداد</option>
                                                                    {col.type === "number" && <option value="AVG">میانگین</option>}
                                                                    {col.type === "number" && <option value="MAX">بیشترین</option>}
                                                                    {col.type === "number" && <option value="MIN">کمترین</option>}
                                                                </select>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>}

                                    {selectedColumns.length > 0 && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>تنظیم نحوه نمایش فیلدهای انتخابی: </label>
                                            <div style={{ marginTop: 15 }}>
                                                <table border="1" cellPadding="5" style={{ width: "100%", background: "#fff" }}>
                                                    <thead>
                                                        <tr>
                                                            <th>ستون</th>
                                                            <th style={{ "width": "130px" }}>نمایش داده شود؟</th>
                                                            <th>عنوان نمایشی (نام مستعار)</th>
                                                            <th style={{ "width": "130px" }}>ترتیب نمایش</th>
                                                            <th style={{ "width": "30px" }}>ترتیب</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {selectedColumns.map((col, idx) => (
                                                            <tr key={col.name}>
                                                                <td>{col.label}</td>
                                                                <td>
                                                                    <input
                                                                        type="checkbox"
                                                                        checked={col.display}
                                                                        onChange={(e) => this.changeDisplay(idx, e.target.checked)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        value={col.alias}
                                                                        onChange={(e) => this.changeAlias(idx, e.target.value)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <select
                                                                        className="form-control"
                                                                        value={col.order}
                                                                        onChange={(e) => this.changeOrderBy(idx, e.target.value)}
                                                                    >
                                                                        <option value="">نیازی نیست</option>
                                                                        <option value="asc">صعودی</option>
                                                                        <option value="desc">نزولی</option>
                                                                    </select>
                                                                </td>
                                                                <td>
                                                                    <span className="fa fa-arrow-down move-down" onClick={() => this.moveColumn(idx, -1)}></span>
                                                                    <span className="fa fa-arrow-up move-up" onClick={() => this.moveColumn(idx, 1)}></span>
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>}

                                    {selectedTables.length > 1 && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>ایجاد ارتباط بین جداول انتخابی: </label>
                                            <div style={{ marginBottom: 15 }}>
                                                {joins.map((j, idx) => (
                                                    <div className="form-inline flex-nowrap gx-3" key={idx} style={{ marginBottom: 8, gap: 15 }}>
                                                        <select
                                                            value={j.from}
                                                            onChange={(e) => this.updateJoin(idx, "from", e.target.value)}
                                                            className="form-control">
                                                            <option value="">انتخاب جدول مبدا</option>
                                                            {selectedTables.map((tbl) => (
                                                                <option key={tbl} value={tbl}>
                                                                    {metadata[tbl].label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        <select
                                                            value={j.fromField}
                                                            onChange={(e) => this.updateJoin(idx, "fromField", e.target.value)}
                                                            className="form-control">
                                                            <option value="">فیلد مبدا</option>
                                                            {j.from &&
                                                                metadata[j.from].fields.map((f) => (
                                                                    <option key={f.name} value={f.name}>
                                                                        {f.label}
                                                                    </option>
                                                                ))}
                                                        </select>

                                                        <select
                                                            value={j.to}
                                                            onChange={(e) => this.updateJoin(idx, "to", e.target.value)}
                                                            className="form-control">
                                                            <option value="">انتخاب جدول مقصد</option>
                                                            {selectedTables.map((tbl, index) => (
                                                                /*چون سلکت کوئری نهایی روی اولین جدول انتخابی هستش.در نتیجه اولین جدول نمیتونه اینجا قرار بگیره*/
                                                                index > 0 && <option key={tbl} value={tbl}>
                                                                    {metadata[tbl].label}
                                                                </option>
                                                            ))}
                                                        </select>

                                                        <select
                                                            value={j.toField}
                                                            onChange={(e) =>
                                                                this.updateJoin(idx, "toField", e.target.value)
                                                            }
                                                            className="form-control">
                                                            <option value="">فیلد مقصد</option>
                                                            {j.to &&
                                                                metadata[j.to].fields.map((f) => (
                                                                    <option key={f.name} value={f.name}>
                                                                        {f.label}
                                                                    </option>
                                                                ))}
                                                        </select>

                                                        <select
                                                            value={j.type}
                                                            onChange={(e) => this.updateJoin(idx, "type", e.target.value)}
                                                            className="form-control">
                                                            <option value="INNER">ارتباط داخلی</option>
                                                            <option value="LEFT">ارتباط با چپ</option>
                                                            <option value="RIGHT">ارتباط با راست</option>
                                                        </select>
                                                    </div>
                                                ))}
                                                <button className="btn btn-primary" onClick={this.addJoin}>+ افزودن ارتباط</button>
                                            </div>
                                        </div>
                                    </div>}
                                    {allFields.length > 1 && <div className="col-sm-12">
                                        <div className="form-group">
                                            <label>تشکیل شرطهای استخراج و نمایش اطلاعات: </label>
                                            <QueryBuilder
                                                fields={allFields}
                                                operators={persianOperators}
                                                combinators={persianCombinators}
                                                query={query}
                                                onQueryChange={this.handleQueryChange}
                                                translations={translations}
                                            />
                                        </div>

                                        <div style={{ direction: "ltr", textAlign: "left", marginTop: 20, background: "#f9f9f9", padding: 10 }}>
                                            <h4>شرط پرس و جوی تولید شده:</h4>
                                            <code>{formatQuery(this.state.query, "sql")}</code>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-dim btn-outline-light" onClick={e => this.closeMe()}>انصراف</button>
                            <button type="submit" onClick={e => this.save(e)} className="btn btn-success">
                                ذخیره
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                this.getGlobalContainer(),
                this.renderForm()
            ];

        return contents;
    }
}